<style scoped>
.main-progress-line {
  position: absolute;
  top: 45px;
  left: 5%;
  width: 90%;
  height: 4px;
  background-color: #dee2e6;
  border-radius: 4px;
  z-index: 1;
}

.filled-progress-line {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease-in-out;
}

.tracker-steps {
  position: relative;
  z-index: 2;
  width: 100%;
  justify-content: space-between;
  overflow-x: auto;
  padding-bottom: 10px;
}

.step-item {
  flex: 1;
  min-width: 100px;
  position: relative;
}

.step-pin {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: #fff;
  border: 3px solid #dee2e6;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.3s ease;
  position: relative;
}

.step-item.completado .step-pin {
  background-color: #28a745;
  border-color: #28a745;
  color: #fff;
}

.step-item.en-curso .step-pin {
  background-color: #17a2b8;
  border-color: #17a2b8;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(23, 162, 184, 0.25);
}

.step-item.completado.annulled .step-pin {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #fff;
}

.btn-eye-mov {
  position: absolute;
  top: -4px;
  right: -8px;
  background-color: #17a2b8;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  font-size: 10px;
  z-index: 3;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.btn-eye-mov:hover,
.btn-eye-mov:focus {
  transform: scale(1.1);
  background-color: #138496;
}

.btn-eye-mov:focus {
  outline: 2px solid #fff;
  outline-offset: 1px;
}

.step-label {
  font-weight: 600;
  font-size: 0.8rem;
  color: #495057;
  line-height: 1.2;
}

.step-date {
  font-size: 0.7rem;
  display: block;
}

.section-disabled {
  opacity: 0.55;
  filter: grayscale(60%);
  pointer-events: none;
}

@media (max-width: 768px) {
  .main-progress-line {
    display: none;
  }

  .tracker-steps {
    flex-direction: column;
    align-items: flex-start;
    padding-left: 20px;
  }

  .step-item {
    display: flex;
    align-items: center;
    text-align: left !important;
    width: 100%;
    margin-bottom: 24px;
    padding: 0;
  }

  .step-pin {
    margin: 0 20px 0 0;
    width: 40px;
    height: 40px;
    font-size: 0.9rem;
    flex-shrink: 0;
  }

  .step-item:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 40px;
    left: 18px;
    width: 4px;
    height: calc(100% - 16px);
    background-color: #dee2e6;
    z-index: 1;
  }

  .step-item.completado:not(:last-child)::after {
    background-color: #28a745;
  }
}
</style>

<template>
  <div class="container-fluid py-3">
    <!-- Botón Atrás & Log Modal -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <router-link class="btn btn-sm btn-outline-info" :to="{ name: 'inventario-tarima' }">
        <i class="fas fa-arrow-left mr-1" aria-hidden="true"></i> Atrás
      </router-link>
      <LogModalComponent modulo="wms" transac="tarima" :id="$route.params.id" />
    </div>

    <!-- Cabecera de Tarima -->
    <div class="card shadow-sm mb-4 border-0 bg-white">
      <div class="card-body p-4">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
          <div>
            <h4 class="mb-1 font-weight-bold text-dark">
              Tarima <span class="text-info">#{{ current.numero }}</span>
            </h4>
            <div class="text-muted small d-flex align-items-center">
              <span class="mr-2">Código de barra: <strong>{{ current.barra }}</strong></span>
              <button
                class="btn btn-sm btn-link py-0 px-1 border-0 text-muted"
                @click="copy_bar()"
                title="Copiar código de barra"
                aria-label="Copiar código de barra al portapapeles"
              >
                <i class="fas fa-copy" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="d-flex flex-wrap align-items-center mt-3 mt-md-0">
            <!-- Tipo de traslado -->
            <span class="badge badge-pill badge-info mr-2 px-3 py-2" v-if="current.tipo_traslado === 'T'">
              <i class="fas fa-exchange-alt mr-1" aria-hidden="true"></i> Traslado
            </span>
            <span class="badge badge-pill badge-warning mr-2 px-3 py-2" v-if="current.tipo_traslado === 'D'">
              <i class="fas fa-undo mr-1" aria-hidden="true"></i> Devolución
            </span>

            <!-- Estado de Tarima -->
            <span v-if="current.estado_str" class="badge badge-pill px-3 py-2 mr-2" :class="estadoBadgeClass">
              <i class="fas fa-info-circle mr-1" aria-hidden="true"></i> {{ current.estado_str }}
            </span>

            <!-- Estado / Acción de Inconsistencia -->
            <!--
              El detalle/edición de la inconsistencia ahora vive en otro componente.
              Este botón solo debe redirigir hacia allá; implementar la navegación
              real en revisarInconsistencia() (ver <script>).
            -->
            <button
              v-if="!current.revisado && current.tuvo_inconsistencia"
              type="button"
              class="btn btn-sm btn-danger px-3 py-2 font-weight-bold shadow-sm"
              @click="revisarInconsistencia"
              aria-label="Ir a revisar la inconsistencia de esta tarima"
            >
              <i class="fas fa-exclamation-triangle mr-1" aria-hidden="true"></i> Revisar Inconsistencia
            </button>
            <span v-else-if="current.revisado" class="badge badge-pill badge-success px-3 py-2">
              <i class="fas fa-check-circle mr-1" aria-hidden="true"></i> Inconsistencia Revisada
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Rastreador de Tarima -->
    <div ref="movimientosRutaCard" class="card shadow-sm mb-4 border-0">
      <div class="card-body pt-2">
        <div class="position-relative">
          <div class="main-progress-line">
            <div
              class="filled-progress-line"
              :class="isTarimaAnnulled ? 'bg-secondary' : 'bg-success'"
              :style="{ width: progresoCalculado + '%' }"
            ></div>
          </div>

          <div class="tracker-steps d-flex">
            <div
              v-for="(paso, index) in pasosCompletados"
              :key="index"
              class="step-item text-center p-2"
              :class="{
                'completado': paso.estado === 'completado',
                'en-curso': paso.estado === 'en_curso',
                'annulled': isTarimaAnnulled
              }"
            >
              <div class="step-pin shadow-sm">
                <i v-if="paso.estado === 'completado'" class="fas fa-check" aria-hidden="true"></i>
                <span v-else>{{ index + 1 }}</span>

                <button
                  v-if="paso.movimiento_salida_id || paso.movimiento_entrada_id"
                  @click="abrirModalMovimiento(paso)"
                  class="btn-eye-mov shadow text-white"
                  title="Ver detalles de movimiento"
                  :aria-label="`Ver movimientos del paso ${paso.nombre}`"
                >
                  <i class="fas fa-eye" aria-hidden="true"></i>
                </button>
              </div>

              <p class="step-label mb-0">{{ paso.nombre }}</p>
              <small class="step-date text-muted" v-if="paso.fecha">{{ paso.fecha }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dos Columnas: Detalle de Tarima (col-lg-8) e Información General (col-lg-4) -->
    <div class="row">
      <!-- Detalle de Tarima -->
      <div class="col-lg-8 mb-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
            <h5 class="card-title text-muted text-uppercase font-weight-bold mb-0">Detalle de Tarima</h5>
          </div>
          <div class="card-body">
            <div
              class="overflow-auto"
              :class="{ 'section-disabled': isTarimaAnnulled }"
              style="max-height: 450px; overflow-y: auto; overflow-x: hidden;"
            >
              <div class="table-responsive" v-if="current.id != null && current.detalle && current.detalle.length">
                <table class="table table-hover table-striped mb-0">
                  <caption class="sr-only">Detalle de productos de la tarima</caption>
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">SKU / Producto</th>
                      <th scope="col" class="text-right">Enviada</th>
                      <th scope="col" class="text-right">Ingresada</th>
                      <th scope="col" class="text-center">Intentos de Conteo</th>
                      <th scope="col" class="text-center">Estatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.detalle"
                      :key="detalle.id"
                      :tabindex="isTarimaAnnulled ? -1 : 0"
                      role="button"
                      :aria-disabled="isTarimaAnnulled"
                      :aria-label="`Ver detalle de ${detalle.producto_obj.sku}`"
                      @click="verDetalleLinea(detalle)"
                      @keyup.enter="verDetalleLinea(detalle)"
                      @keyup.space.prevent="verDetalleLinea(detalle)"
                      title="Haga clic para ver detalles del producto"
                    >
                      <td class="align-middle">
                        <span class="font-weight-bold text-dark">{{ detalle.producto_obj.sku }}</span>
                        <span class="text-muted d-block small">{{ detalle.producto_obj.nombre }}</span>
                      </td>
                      <td class="text-right align-middle font-weight-bold text-success">
                        {{ detalle.total_enviada || 0 }}
                      </td>
                      <td class="text-right align-middle font-weight-bold" :class="{
                        'text-success': detalle.total_enviada == detalle.total_recibida,
                        'text-danger': detalle.total_enviada != detalle.total_recibida,
                      }">
                        {{ detalle.total_recibida || 0 }}
                      </td>
                      <td class="text-center align-middle font-weight-bold" :class="{
                        'text-success': detalle.intentos_conteo_destino <= detalle.intentos_maximos_destino,
                        'text-danger': detalle.intentos_conteo_destino > detalle.intentos_maximos_destino,
                      }">
                        {{ detalle.intentos_conteo_destino || 0 }}
                      </td>
                      <td class="text-center align-middle">
                        <span  v-if="current.estado!='9'" class="badge badge-pill" :class="detalle.inconsistencia ? 'badge-danger' : 'badge-success'">
                          {{ detalle.inconsistencia ? 'Inconsistente' : 'Correcto' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center text-muted py-5">
                <i class="fas fa-box-open fa-3x mb-3 text-muted" aria-hidden="true"></i>
                <p class="mb-0">No hay detalles disponibles para esta tarima.</p>
              </div>
            </div>
            <div class="text-right mt-3" v-if="current.id == null">
              <button class="btn btn-success px-4" type="submit">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Información General -->
      <div class="col-lg-4 mb-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-bottom-0 pt-3 pb-0">
            <h5 class="card-title text-muted text-uppercase font-weight-bold mb-0">Información General</h5>
          </div>
          <div class="card-body">
            <div class="list-group list-group-flush mb-4">
              <div class="list-group-item px-0 py-2 border-0">
                <small class="text-muted d-block">Tienda Origen</small>
                <span class="font-weight-bold text-dark" v-if="current.tienda_origen_obj">{{ current.tienda_origen_obj.nombre }}</span>
                <span class="text-muted" v-else>N/A</span>
              </div>
              <div class="list-group-item px-0 py-2 border-top border-bottom-0">
                <small class="text-muted d-block">Tienda Destino</small>
                <span class="font-weight-bold text-dark" v-if="current.tienda_destino_obj">{{ current.tienda_destino_obj.nombre }}</span>
                <span class="text-muted" v-else>N/A</span>
              </div>
              <div class="list-group-item px-0 py-2 border-top border-bottom-0">
                <small class="text-muted d-block">Usuario</small>
                <span class="font-weight-bold text-dark" v-if="current.usuario && current.usuario.username">{{ current.usuario.username }}</span>
                <span class="text-muted" v-else>N/A</span>
              </div>
              <div class="list-group-item px-0 py-2 border-top border-bottom-0">
                <small class="text-muted d-block">Posición</small>
                <span class="font-weight-bold text-dark" v-if="current.posicion">{{ current.posicion.barra }}</span>
                <span class="text-muted" v-else>N/A</span>
              </div>
            </div>

            <!-- Documentos de Traslado -->
            <div class="mb-4" v-if="current.salida_traslado_e || current.entrada_traslado_e">
              <h6 class="text-muted font-weight-bold mb-2 text-uppercase small">Documentos Relacionados</h6>
              <router-link
                target="_blank"
                rel="noopener noreferrer"
                v-if="current.salida_traslado_e"
                class="btn btn-outline-info btn-block btn-sm mb-2 text-left"
                :to="{
                  name: 'inventario-salida_traslado-editar',
                  params: { id: current.salida_traslado_e.id },
                }"
              >
                <i class="fas fa-sign-out-alt mr-2" aria-hidden="true"></i> Ver Salida Traslado
              </router-link>

              <router-link
                target="_blank"
                rel="noopener noreferrer"
                v-if="current.entrada_traslado_e"
                class="btn btn-outline-info btn-block btn-sm text-left"
                :to="{
                  name: 'inventario-entrada_traslado-editar',
                  params: { id: current.entrada_traslado_e },
                }"
              >
                <i class="fas fa-sign-in-alt mr-2" aria-hidden="true"></i> Ver Entrada Traslado
              </router-link>
            </div>

            <!-- Acciones generales -->
            <div class="mb-4">
              <h6 class="text-muted font-weight-bold mb-2 text-uppercase small">Acciones</h6>
              <button class="btn btn-block btn-info btn-sm mb-2 text-left" type="button" @click="imprimir">
                <i class="fas fa-print mr-2" aria-hidden="true"></i> Imprimir Reporte
              </button>
              <button type="button" class="btn btn-block btn-outline-dark btn-sm text-left" data-toggle="modal" data-target="#modalLog">
                <i class="fas fa-history mr-2" aria-hidden="true"></i> Ver Registro de Log
              </button>
            </div>

            <!-- Comentario / Observación (solo lectura) -->
            <div class="border-top pt-3">
              <h6 id="comentarioLabel" class="text-muted font-weight-bold mb-2 text-uppercase small">
                Comentario / Observación
              </h6>
              <div
                class="bg-light border rounded p-2 overflow-auto"
                style="max-height: 180px;"
                role="region"
                aria-labelledby="comentarioLabel"
              >
                <p class="mb-0 text-dark" v-if="current.observacion" style="white-space: pre-wrap;">{{ current.observacion }}</p>
                <p class="mb-0 text-muted font-italic" v-else>Sin comentarios registrados.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Movimientos de Inventario por Ruta (componente separado y reutilizable) -->
    <MovimientosTarimaModalComponent ref="movimientosModal" />

    <!-- Modal Detalle Tarima Producto -->
    <div
      aria-hidden="true"
      class="modal fade"
      id="onboardingSlideModal"
      role="dialog"
      tabindex="-1"
      aria-labelledby="onboardingSlideModalLabel"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content border-0 shadow">
          <div class="modal-header bg-info text-white">
            <h5 class="modal-title font-weight-bold" id="onboardingSlideModalLabel">
              <i class="fas fa-info-circle mr-2" aria-hidden="true"></i> Detalle de Tarima Producto
            </h5>
            <button aria-label="Cerrar" class="close text-white" @click="hideModal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive" v-if="current.id != null && currentDetalle && currentDetalle.tarimaproductod_set">
              <table class="table table-hover table-striped table-bordered mb-0">
                <caption class="sr-only">Sub-detalle del producto seleccionado</caption>
                <thead class="thead-light">
                  <tr>
                    <th scope="col">SKU / Producto</th>
                    <th scope="col" class="text-right">Enviada</th>
                    <th scope="col" class="text-right">Ingresada</th>
                    <th scope="col">Motivo Devolución</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in currentDetalle.tarimaproductod_set" :key="detalle.id">
                    <td class="align-middle">
                      <span class="font-weight-bold text-dark" v-if="currentDetalle.producto_obj">{{ currentDetalle.producto_obj.sku }}</span>
                      <span class="text-muted d-block small" v-if="currentDetalle.producto_obj">{{ currentDetalle.producto_obj.nombre }}</span>
                    </td>
                    <td class="text-right align-middle font-weight-bold text-success">
                      {{ detalle.cantidad || 0 }}
                    </td>
                    <td class="text-right align-middle font-weight-bold" :class="{
                      'text-success': detalle.cantidad == detalle.recibida,
                      'text-danger': detalle.cantidad != detalle.recibida,
                    }">
                      {{ detalle.recibida || 0 }}
                    </td>
                    <td class="align-middle">
                      <span v-if="detalle.salida_traslado_d && detalle.salida_traslado_d.motivo_devolucion">
                        {{ detalle.salida_traslado_d.motivo_devolucion.descripcion }}
                      </span>
                      <span class="text-muted small" v-else>N/A</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center text-muted py-4">
              No hay sub-detalles disponibles para esta línea.
            </div>
          </div>
          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-secondary px-4" @click="hideModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import LogModalComponent from "@/components/commons/LogModalComponent";
import MovimientosTarimaModalComponent from "./MovimientosTarimaModalComponent";
export default {
  components: {
    LogModalComponent,
    MovimientosTarimaModalComponent,
  },
  data() {
    return {
      current: {},
      currentDetalle: {},
      rutaTarima: [],
    };
  },
  computed: {
    pasosCompletados() {
      return this.rutaTarima.filter(p => p.estado === 'completado');
    },
    // El rastreador ahora solo muestra pasos completados, así que la barra
    // se calcula en relación con esos mismos pines: llena si hay al menos
    // uno completado, vacía si aún no hay ninguno.
    progresoCalculado() {
      return this.pasosCompletados.length ? 100 : 0;
    },
    // Condición central: la tarima fue anulada. Se usa tanto en el rastreador
    // (pasos completados en gris) como en el bloque de Detalle de Tarima
    // (sección atenuada/deshabilitada). String() evita fallos si el backend
    // envía el estado como número o como texto.
    isTarimaAnnulled() {
      return String(this.current.estado) === "9";
    },

    estadoBadgeClass() {
      const mapping = {
        A: "badge-success",
        9: "badge-danger",
        C: "badge-primary",
        E: "badge-info",
        F: "badge-secondary",
        G: "badge-warning",
        H: "badge-dark",
      };
      return mapping[this.current.estado] || "badge-secondary";
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.refreshCurrent(this.$route.params.id);
    }
  },
  methods: {
    /**
     * Redirige al componente externo donde ahora se gestiona la revisión
     * de inconsistencias de la tarima.
     * TODO: completar la navegación real, p. ej.:
     * this.$router.push({ name: 'NOMBRE_DE_LA_RUTA', params: { id: this.current.id } });
     */
    revisarInconsistencia() {
      // Implementar navegación al nuevo componente de revisión de inconsistencias.
    },
    abrirModalMovimiento(paso) {
      if (!paso) return;
      const pasoKey = `${paso.orden || 0}-${paso.nombre || "paso"}`;
      if (this.$refs.movimientosModal) {
        this.$refs.movimientosModal.open(this.$route.params.id, pasoKey);
      }
    },

    imprimir() {
      if (!this.current.id) return;
      const id = encodeURIComponent(this.current.id.replace(/-/g, ""));
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/inconsistencias.jrxml&id=${id}`,
        "_blank",
        "noopener,noreferrer"
      );
    },
    copy_bar() {
      if (this.current.barra) {
        navigator.clipboard.writeText(this.current.barra)
          .then(() => {
            Notifications.alert.success(
              "Copiado",
              "Código de barra copiado al portapapeles"
            );
          })
          .catch(() => {
            Notifications.alert.error(
              "Error",
              "No se pudo copiar el código de barra"
            );
          });
      }
    },
    hideModal() {
      $("#onboardingSlideModal").modal("hide");
    },
    verDetalleLinea(detalle) {
      // La sección ya queda visualmente deshabilitada (pointer-events: none)
      // cuando la tarima está anulada; este guard evita que se abra el modal
      // si la fila se activa por teclado (Enter/Espacio).
      if (this.isTarimaAnnulled) return;
      this.currentDetalle = detalle;
      $("#onboardingSlideModal").modal("show");
    },

    cargarRastreadorRuta(tarimaId) {
      DynamicService.getAction("wms", "tarima", tarimaId, "rastreador_ruta", {})
        .then((response) => {
          this.rutaTarima = response.data.pasos || [];
        })
        .catch(() => {
          this.rutaTarima = [];
          Notifications.alert.error(
            "Rastreador de Tarima",
            "No fue posible cargar la ruta de la tarima."
          );
        });
    },
    refreshCurrent(params) {
      DynamicService.getById("wms", "tarima", params)
        .then((response) => {
          this.current = response.data;
          this.refreshPosicon();
          this.cargarRastreadorRuta(params);
        })
        .catch(() => {
          Notifications.alert.error(
            "Tarima",
            "No fue posible cargar la información de la tarima."
          );
        });
    },
    refreshPosicon() {
      if (!this.current.posicion) return;
      DynamicService.getById(
        "cat",
        "tienda-posicion",
        this.current.posicion
      )
        .then((response) => {
          this.current.posicion = response.data;
        })
        .catch(() => {
          Notifications.alert.error(
            "Posición",
            "No fue posible cargar la posición de la tarima."
          );
        });
    },
  },
};
</script>